<template>
    <div class="modal-mask type2">
        <div class="modal-wrapper">
            <div class="modal_size sm3_size">
                <a href="javascript:" class="ui_close_type2" type="button" @click="goListBack">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <div class="container register">
                        <div class="title">
                            <h1>{{ data.msg1 }}</h1>
                        </div>
                        <div class="content" ng-init="">
                            <div class="one-register">
                                <dl class="register_end_txt">
                                    <dt>
                                        {{ data.msg3 }}
                                        {{ data.msg4 }}
                                        {{ data.msg5 }}
                                    </dt>
                                    <dd>
                                        <div>[{{ $t('FIELD.EUR.NOTE') }}]</div>
                                        <div style="text-align:left">1. {{ $t('MESSAGE.EUR.USER.RULES.ONE') }}</div>
                                        <div style="text-align:left" v-show="data.show">2. {{ $t('MESSAGE.EUR.USER.RULES.TWO', [data.mon]) }}</div>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { SDLUtil } from '@/utils';

export default {
    name: 'RequestSuccPopup',
    props: {
        data: { type: Object, default: {} },
        rtnFunc: {
            type: Function,
        },
    },
    methods: {
        goListBack() {
            this.$router.push(`${SDLUtil.WEB_CONTEXT_PATH}/erp/repairInfoHist`);
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/RequestSuccPopup.vue